import React, { useState, useEffect, useCallback } from 'react';
import axios from 'axios';
import { Table, Spinner } from 'react-bootstrap';
import { TransitionGroup, CSSTransition } from 'react-transition-group';
import Trofeu from '../../assets/images/trofeu.png';
import WiFi from '../../assets/images/WiFi.png';
import './styles.css';

function RealTimeLeaderboard() {
  const [scores, setScores] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [topic, setTopic] = useState('geral'); // valor padrão caso não haja tópico na URL

  // Extrai o tópico da URL usando window.location.pathname
  useEffect(() => {
    // Exemplo: se URL for "/seguranca", pathname será "/seguranca"
    const path = window.location.pathname; 
    const segments = path.split('/');
    // Se existir um segmento na posição 1, usamos; caso contrário, "geral"
    if (segments.length > 1 && segments[1]) {
      // Normaliza: remove acentos e transforma para minúsculas
      const normalized = segments[1]
                            .normalize('NFD')
                            .replace(/[\u0300-\u036f]/g, '')
                            .toLowerCase();
      setTopic(normalized);
    } else {
      setTopic('geral');
    }
  }, []);
  
  const apiUrl = 'https://automacao.gigabytetelecom.com.br:3009';

  const fetchLeaderboard = useCallback(async () => {
    try {
      const url = topic !== 'geral'
        ? `${apiUrl}/leaderboard?quizTopic=${encodeURIComponent(topic)}`
        : `${apiUrl}/leaderboard`;
      const response = await axios.get(url);
  
      // Atualiza apenas se houve alteração
      const newScores = response.data;
      const isEqual = JSON.stringify(scores) === JSON.stringify(newScores);
      if (!isEqual) {
        setScores(newScores);
      }
  
      setError('');
    } catch (err) {
      console.error('Erro ao buscar ranking:', err);
      setError('Erro ao carregar dados.');
    } finally {
      if (loading) setLoading(false); // Só tira o loading se for o primeiro carregamento
    }
  }, [topic, apiUrl, scores, loading]);

  useEffect(() => {
    fetchLeaderboard();
    const intervalId = setInterval(fetchLeaderboard, 5000);
    return () => clearInterval(intervalId);
  }, [fetchLeaderboard]);

  // Calcula a média dos ratings (apenas scores com rating definido)
  const ratings = scores
    .map(score => score.rating)
    .filter(r => r !== undefined && r !== null);
  const averageRating = ratings.length > 0
    ? (ratings.reduce((acc, cur) => acc + cur, 0) / ratings.length).toFixed(1)
    : 'N/A';

  // Função para renderizar as estrelas (❤ para preenchida, 🤍 para vazia)
  const renderStars = (rating) => {
    const fullStars = Math.floor(rating);
    const emptyStars = 5 - fullStars;
    return '★'.repeat(fullStars) + '☆'.repeat(emptyStars);
  };

  if (loading) {
    return (
      <div className="loading">
        <Spinner animation="border" variant="primary" />
      </div>
    );
  }
  if (error) return <div className="error">{error}</div>;

  const isSeguranca = topic === 'seguranca';

  return (
    <div className="leaderboard-container">
      <div className="trofeu row">
        <div className="trofeu-img col-sm-12 col-md-8">
        <img src={isSeguranca ? Trofeu : WiFi} alt="brasao" />
          {/* <img src={Trofeu} alt="trofeu" /> */}
          <h2>
            Ranking da Competição 
            {/* ({topic}) */}
          </h2>
        </div>
        <div className="btn btn-outline-success col-sm-12 col-md-4">
          <h4>Total de Participantes: {scores.length}</h4>
        </div>
        <div className="title-container-sub">
          <h5>Confira os melhores desempenhos e veja quem se destacou!</h5>
        </div>
      </div>
      <Table className="table-zebrada">
        <thead>
          <tr>
            <th>Posição</th>
            <th>Nome</th>
            <th>Acertos</th>
            <th>Tempo (s)</th>
            <th>Data</th>
            <th>Rating</th>
          </tr>
        </thead>
        <TransitionGroup component="tbody">
          {scores.map((score, index) => (
            <CSSTransition key={score._id} timeout={500} classNames="row">
              <tr className={index % 2 === 0 ? 'even-row' : 'odd-row'}>
                <td>{index + 1}</td>
                <td>{score.userName}</td>
                <td>{score.correctAnswers.toFixed(1)}%</td>
                <td>{score.timeSpent}</td>
                <td>{new Date(score.createdAt).toLocaleString()}</td>
                <td className="rating">{score.rating ? renderStars(score.rating) : 'N/A'}</td>
              </tr>
            </CSSTransition>
          ))}
        </TransitionGroup>
      </Table>
      <div className="average-rating">
        <h3>Média do Rating: {averageRating}</h3>
      </div>
    </div>
  );
}

export default RealTimeLeaderboard;
